import { GlDisclosureDropdown, GlDisclosureDropdownItem, GlDisclosureDropdownGroup } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { ORDERED_GENERAL_ACTIONS, ORDERED_DANGER_ACTIONS, DEFAULT_ACTION_ITEM_DEFINITIONS, ACTION_EDIT, ACTION_ARCHIVE, ACTION_UNARCHIVE, ACTION_LEAVE, ACTION_RESTORE, ACTION_DELETE, ACTION_DELETE_IMMEDIATELY } from './constants';
export default {
    name: 'ListActions',
    ACTION_EDIT,
    ACTION_ARCHIVE,
    ACTION_UNARCHIVE,
    ACTION_LEAVE,
    ACTION_RESTORE,
    ACTION_DELETE,
    ACTION_DELETE_IMMEDIATELY,
    components: {
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlDisclosureDropdownGroup
    },
    props: {
        actions: {
            type: Object,
            required: true
        },
        availableActions: {
            type: Array,
            required: true
        }
    },
    computed: {
        generalActions () {
            return ORDERED_GENERAL_ACTIONS.filter((action)=>this.availableActions.includes(action) && this.actionItem(action));
        },
        dangerActions () {
            return ORDERED_DANGER_ACTIONS.filter((action)=>this.availableActions.includes(action) && this.actionItem(action));
        },
        hasDangerActions () {
            return this.dangerActions.length;
        },
        customActions () {
            const baseActionKeys = Object.keys(DEFAULT_ACTION_ITEM_DEFINITIONS);
            return Object.entries(this.actions).reduce((accumulator, [key, value])=>{
                if (baseActionKeys.includes(key)) {
                    return accumulator;
                }
                return {
                    ...accumulator,
                    [key]: value
                };
            }, {});
        }
    },
    methods: {
        actionItem (action) {
            return {
                ...DEFAULT_ACTION_ITEM_DEFINITIONS[action],
                ...this.actions[action]
            };
        }
    }
};
